import { Col, Row } from "antd";
import { CSSProperties, ReactNode } from "react";
import Text from "../Text/Text";
import color from "../../resource/color";

interface DescSumOrderProps {
  label: any;
  value?: string | ReactNode;
  leftSpan?: number;
  noColon?: boolean;
  sum: boolean;
}

const DescSumOrder = ({ label, value, leftSpan = 8, noColon, sum }: DescSumOrderProps) => {
  return (
    <>
      <Row
        style={{ padding: "4px 18px", backgroundColor: sum ? color.primary : "#0068F433" }}
        align='top'
      >
        <Col span={leftSpan}>
          <Text
            fontFamily='Sarabun'
            color={sum ? "white" : "Text1"}
            style={{ fontWeight: sum ? 700 : 400 } as CSSProperties}
          >
            {label}&nbsp;{noColon ? "" : ":"}
          </Text>
        </Col>
        <Col span={24 - leftSpan}>
          <Text
            fontFamily='Sarabun'
            color={sum ? "white" : "Text1"}
            style={{ fontWeight: sum ? 700 : 400 } as CSSProperties}
          >
            {value || "-"}
          </Text>
        </Col>
      </Row>
    </>
  );
};

export default DescSumOrder;
